//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Message from './Message'

export default {
    name: 'CourierPane',
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        headUrl: {
            type: String,
            default: require('~/assets/images/head.png')
        },
        messages: {
            type: Array,
            default: () => []
        },
        isTourist: {
            type: Boolean,
            required: true
        },
        paneUpdater: {
            type: Object,
            required: true
        },
        noMore: {
            type: Boolean,
            default: false
        },
        clientName: {
            type: String,
            required: true
        },
        clientHeadUrl: {
            type: String,
            default: require('~/assets/images/head.png')
        },
        clientType: {
            type: String,
            required: true
        }
    },
    components: { Message },
    data() {
        return {
            preId: null,
            scroll: false
        }
    },
    watch: {
        paneUpdater(newVal) {
            const { visitorId, scrollToBottom } = newVal
            if (visitorId === this.id) {
                this.$forceUpdate()
                if (scrollToBottom) {
                    this.scrollToBottom()
                }
            }
        }
    },
    updated() {
        if (!this.preId) {
            this.preId = this.messages[0] ? this.messages[0].id : null
            return
        }

        if (this.scroll) {
            const preEle = this.$refs[`msg-${this.id}-${this.preId}`][0].$el
            const body = this.$refs[`body${this.id}`]
            body.scrollTop = preEle.offsetTop
            this.preId = this.messages[0].id
            this.scroll = false
        }
    },
    methods: {
        handleHeadClick() {
            console.log(this.headUrl)
            console.log(this.clientHeadUrl)
        },

        scrollToBottom() {
            setTimeout(() => {
                const body = this.$refs[`body${this.id}`]
                body.scrollTop = body.scrollHeight
            }, 200)
        },

        handleBodyScroll(e) {
            const ele = e.target
            if (!this.noMore && ele.scrollTop === 0) {
                this.scroll = true
                this.$emit('getMessages', this.id, false)
            }
        },

        toLogin() {
            this.$store.dispatch('setCourierStatus', {
                type: this.clientType,
                status: {
                    visible: false
                }
            })
            this.$router.push('/login')
        }
    }
}
